import moment from 'moment';
import { Csp } from '../affilie';
import { CodeCerfa } from '../scenarii';
import { TypeAttestation } from '../typeAttestation';
import { TypeDeclaration } from '../typeChoix';

export const getSalaryMinimumS6202Rules = (store) => {
    let hasSalaryMinimumS6202 = false;
    let hasSalaryMinimumContratS6202 = false;

    const age = moment().diff(moment(store.affilie.birthDate), 'years');
    const hasLess18 = age < 18;

    if (store.cerfa === CodeCerfa.S6202 && store.typeDeclarationCod === TypeDeclaration.Choice2 && store.typeAttestation !== TypeAttestation.Over6Months) {
        if (hasLess18 || store.affilie.qualificationCod === Csp.ProfessionalTrainees) {
            hasSalaryMinimumS6202 = true;
        }
        if (store.affilie.qualificationCod === Csp.Apprentices) {
            hasSalaryMinimumS6202 = true;
            hasSalaryMinimumContratS6202 = true;
        }
    }

    const displaySalaryMinimumS6202 = hasLess18 || hasSalaryMinimumS6202;

    return { hasLess18, hasSalaryMinimumContratS6202, displaySalaryMinimumS6202 };
};
